export const ActionTypes = {
  ACTION_SHIPMENT_INIT: "ACTION_SHIPMENT_INIT",
  ACTION_SHIPMENT_START: "ACTION_SHIPMENT_START",
  ACTION_SHIPMENT_SUCCESS: "ACTION_SHIPMENT_SUCCESS",
  ACTION_SHIPMENT_FAILED: "ACTION_SHIPMENT_FAILED",

  ACTION_SHIPMENT_BY_USER_SUCCESS: "ACTION_SHIPMENT_BY_USER_SUCCESS",
  ACTION_SHIPMENT_BY_USER_FAILED: "ACTION_SHIPMENT_BY_USER_FAILED",
  ACTION_SHIPMENT_BY_USER_START: "ACTION_SHIPMENT_BY_USER_START",
  ACTION_SHIPMENT_BY_USER_INIT: "ACTION_SHIPMENT_BY_USER_INIT",

  ACTION_PORTS_SUCCESS: "ACTION_PORTS_SUCCESS",
  ACTION_PORTS_FAILED: "ACTION_PORTS_FAILED",
  ACTION_PORTS_START: "ACTION_PORTS_START",
  ACTION_PORTS_INIT: "ACTION_PORTS_INIT",

  ACTION_SHIPMENT_DELETE_START: "ACTION_SHIPMENT_DELETE_START",
  ACTION_SHIPMENT_DELETE_SUCCESS: "ACTION_SHIPMENT_DELETE_SUCCESS",
  ACTION_SHIPMENT_DELETE_FAILED: "ACTION_SHIPMENT_DELETE_FAILED",

  ACTION_SHIPMENT_REFRESH_START: "ACTION_SHIPMENT_REFRESH_START",
  ACTION_SHIPMENT_REFRESH_SUCCESS: "ACTION_SHIPMENT_REFRESH_SUCCESS",
  ACTION_SHIPMENT_REFRESH_FAILED: "ACTION_SHIPMENT_REFRESH_FAILED",

  ACTION_SOLDE_SUCCESS: "ACTION_SOLDE_SUCCESS",
  ACTION_SOLDE_FAILED: "ACTION_SOLDE_FAILED",
  ACTION_SOLDE_START: "ACTION_SOLDE_START",
  ACTION_SOLDE_INIT: "ACTION_SOLDE_INIT",
};
